"use strict";Object.defineProperty(exports, "__esModule", {value: true});var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// index.js
var _bearing = require('@turf/bearing');
var _destination = require('@turf/destination');
var _distance = require('@turf/distance');
function midpoint(point1, point2) {
  var dist = _distance.distance.call(void 0, point1, point2);
  var heading = _bearing.bearing.call(void 0, point1, point2);
  var midpoint2 = _destination.destination.call(void 0, point1, dist / 2, heading);
  return midpoint2;
}
__name(midpoint, "midpoint");
var turf_midpoint_default = midpoint;



exports.default = turf_midpoint_default; exports.midpoint = midpoint;
//# sourceMappingURL=index.cjs.map